import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { useUserState } from '../../auth/UserState';
import { ClarionButton } from '../../clarion/ClarionButton';
import RecapLogo from '../../shared/RecapLogo';
import { useMediaQuery } from '../../shared/useMediaQuery';
import { MobileNavigationDrawer } from './MobileNavigationDrawer';

export function MobileTopNavigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { status } = useUserState();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const location = useLocation();

  const signedIn = status === 'signedIn';

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Only show on mobile and when signed in
  if (!isMobile || !signedIn) {
    return null;
  }

  return (
    <nav className="sticky top-0 z-20 bg-white dark:bg-[#202124] h-16 flex items-center justify-between px-4 border-b border-gray-200 dark:border-gray-600">
      <ClarionButton
        variant="minimal"
        size="large"
        tooltip="Navigation menu"
        aria-haspopup="dialog"
        onClick={() => setIsMenuOpen(true)}
        icon="menu"
      />

      <Link to="/" className="flex items-center">
        <RecapLogo />
      </Link>

      <div className="w-10" />

      <MobileNavigationDrawer isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </nav>
  );
}
